import * as AnnouncementAPI from './announcement'
import * as AchievementAPI from './achievement'
import * as PortofolioAPI from './portofolio'
import * as ViewAPI from './view'
import * as UserAPI from './user'
import * as AuthAPI from './auth'
import * as ProfileAPI from './profile'
import * as ConfigAPI from './config'
import * as CareerAPI from './career'
import * as TypetalkAPI from './typetalk'
import * as SearchHistoryAPI from './searchHistory'

export default {
  announcement: {
    ...AnnouncementAPI
  },
  achievement: {
    ...AchievementAPI
  },
  portofolio: {
    ...PortofolioAPI
  },
  view: {
    ...ViewAPI
  },
  user: {
    ...UserAPI
  },
  auth: {
    ...AuthAPI
  },
  profile: {
    ...ProfileAPI
  },
  typetalk: {
    ...TypetalkAPI
  },
  config: {
    ...ConfigAPI
  },
  career: {
    ...CareerAPI
  },
  log: {
    ...SearchHistoryAPI
  }
}
